import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
} from "chart.js";
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels, LineElement, PointElement);

const index = ({ data, options }: any) => {
  return <Line data={data} options={options} height={300}/>;
};

export default index;
